import { render, staticRenderFns } from "./boolean-question.vue?vue&type=template&id=3c012c44"
import script from "./boolean-question.vue?vue&type=script&lang=js"
export * from "./boolean-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports